<template>
  <UtilityFormField
    title="Name"
    :field-id="inputId"
    description="(used for collaboration)"
    :error="showValidation ? error : undefined"
  >
    <input
      :id="inputId"
      ref="input"
      type="text"
      name="name"
      :value="modelValue"
      :disabled="disabled"
      data-input="text"
      autocomplete="name"
      required
      @input="
        $emit('update:modelValue', ($event.target as HTMLInputElement).value)
      "
      @blur="showValidation = true"
    />
  </UtilityFormField>
</template>

<script lang="ts">
import { v4 as uuid } from 'uuid';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AccountFieldName',
  props: {
    modelValue: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  emits: {
    'update:modelValue': (_value: string) => true,
  },
  data() {
    return {
      error: '',
      showValidation: false,
    };
  },
  computed: {
    inputId() {
      return `name-${uuid()}`;
    },
  },
  watch: {
    modelValue() {
      const input = this.$refs.input as HTMLInputElement;
      this.error = input.validationMessage;
    },
  },
});
</script>
